import { AppUrls } from '@/enums'
import { InterfaceAppLink } from '@/interfaces'

export const SITE_NAME = 'Application name'
export const IS_DEV = process.env.NODE_ENV === 'development'
export const SITE_DOMAIN = IS_DEV ? 'http://localhost:3000' : `https://chart-builder-for-coinshares.vercel.app`
export const SITE_URL = SITE_DOMAIN.replace('www.', '')
export const SITE_ICON = `${SITE_DOMAIN}/public/icons/512.png`

export const APP_PAGES: InterfaceAppLink[] = [
    {
        name: 'Home',
        path: AppUrls.HOME,
    },
    {
        name: 'Sign Up',
        path: AppUrls.SIGN_UP,
    },
    {
        name: 'Dashboard',
        path: AppUrls.DASHBOARD,
    },
    {
        name: 'Account',
        path: AppUrls.ME,
    },
    {
        name: 'Sign In',
        path: AppUrls.SIGN_IN,
    },
    {
        name: 'Forgot Password',
        path: AppUrls.RESET_PASSWORD,
    },
    {
        name: 'Verify Email',
        path: AppUrls.VERIFY_EMAIL,
    },
    {
        name: 'Changelog',
        path: AppUrls.CHANGELOG,
    },
] as const

export const APP_METADATA = {
    SITE_NAME,
    SITE_DOMAIN,
    SITE_DESCRIPTION: 'Charts tooling',
    SITE_URL,
    SITE_ICON,
}
